import { CircularProgress, Page, PageFace } from 'ui/components'

import { Footer, Form } from './components'
import { useEdit } from './useEdit'

const Manage = () => {
  const { cancelManage, data, formApi, isFetching, isPending, isSuccess, SaveConfirmation, submitForm } = useEdit()

  if (isFetching && !data) {
    return <CircularProgress centered />
  }

  if (!data) {
    return null
  }

  const { companyName, formattedNumber, licenseOptions } = data

  return (
    <Page
      face={PageFace.SECONDARY}
      title={formattedNumber}
      subTitle="Edit Bank Account"
      isPending={isFetching}
      footer={
        <formApi.Subscribe
          children={({ isSubmitting }) => (
            <Footer onCancel={cancelManage} onSubmit={submitForm} loading={isSubmitting || isPending} />
          )}
        />
      }
    >
      <SaveConfirmation />
      <Form
        licenses={licenseOptions}
        companyName={companyName}
        isSubmitting={isPending}
        isSuccess={isSuccess}
        formApi={formApi}
      />
    </Page>
  )
}

export default Manage
